import type { IAdminTransaction, ITransaction } from "@gen/app-query";

import { TransactionMoney } from "~/entities/transaction";

interface SellerPayoutCellProps {
  transactionData: ITransaction | IAdminTransaction;
}

export function SellerPayoutCell({ transactionData }: SellerPayoutCellProps) {
  return new TransactionMoney(transactionData).getSellerPayout().format();
}
